module.exports = __webpack_public_path__ + "img/warabee1.18ffbabb.jpg";